import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../activity/winter-vacation-2023-excellent/index.vue')

export const indexRoute: RouteConfig = {
  path: '/winter-vacation-2023-excellent',
  name: 'winter_vacation_2023_excellent',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '优秀寒假作业案例合集',
    ignoreLogin: true,
  },
}

export default [indexRoute]

export function navigateToWinterVacation2023Excellent(router: VueRouter) {
  router.push({ name: indexRoute.name })
}
